// extracted by mini-css-extract-plugin
export default {"InputAlignmentContainer":"Go_d8Mfs"};